import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "mr-10 -mt-15"
}
const _hoisted_3 = ["id", "name", "checked", "disabled", "onClick"]
const _hoisted_4 = ["for"]
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = { class: "flex-1 ml-20" }
const _hoisted_7 = { class: "font-normal" }
const _hoisted_8 = {
  key: 0,
  class: "text-roman"
}

import { Ref, ref, watch } from 'vue';
import { remove } from 'lodash';
import { useVModel } from '@vueuse/core';
import { DeliverableSelectItem } from '@/storecontext/basket/useDeliverables';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketDeliverableItemsSelection',
  props: {
    items: null,
    errorLabel: { default: undefined },
    selected: { default: undefined },
    readOnly: { type: Boolean, default: false }
  },
  emits: ['update:selected', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { items: DeliverableSelectItem[], errorLabel: string, selected: DeliverableSelectItem[], readOnly: boolean }





const internalSelected: Ref<DeliverableSelectItem[]> = ref([]);
const externalSelected: Ref<DeliverableSelectItem[] | undefined> = useVModel(props, 'selected', emit);

watch(externalSelected, value => {
    if (value !== undefined && value !== internalSelected.value) {
        internalSelected.value = value;
    }
}, { immediate: true });

const update = (): void => {
    externalSelected.value = internalSelected.value;
    emit('change', internalSelected.value);
};

const getIsSelected = (item: DeliverableSelectItem): boolean => {
    return internalSelected.value.indexOf(item) > -1;
};

const toggleSelected = (item: DeliverableSelectItem): void => {
    if (!item.selectable) {
        return;
    }
    if (getIsSelected(item)) {
        remove(internalSelected.value, (i: DeliverableSelectItem) => i.sku === item.sku);
    } else {
        internalSelected.value.push(item);
    }
    update();
};

const visuallySelectable = (item: DeliverableSelectItem): boolean => {
    return item.selectable && !props.readOnly;
};


return (_ctx: any,_cache: any) => {
  const _component_ProductImage = _resolveComponent("ProductImage")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createElementBlock("article", {
        key: item.sku,
        class: _normalizeClass(["flex flex-nowrap items-center text-left mb-20 last:mb-0", {'cursor-default': !visuallySelectable(item), 'cursor-pointer': visuallySelectable(item)}]),
        onClick: ($event: any) => (toggleSelected(item))
      }, [
        (!__props.readOnly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["c-checkbox", {'opacity-25': !item.selectable}])
              }, [
                _createElementVNode("input", {
                  id: item.sku,
                  type: "checkbox",
                  name: item.name,
                  checked: getIsSelected(item),
                  disabled: !item.selectable,
                  class: "c-checkbox__field",
                  onClick: ($event: any) => (toggleSelected(item))
                }, null, 8, _hoisted_3),
                _createElementVNode("label", {
                  for: item.sku,
                  class: _normalizeClass(["c-checkbox__label", {'cursor-default': !item.selectable}])
                }, null, 10, _hoisted_4)
              ], 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ProductImage, {
            sku: item.sku,
            alt: item.name,
            "aspect-ratio": 5/3,
            "width-on-screen": 1,
            class: _normalizeClass(["w-full", {'opacity-50': !item.selectable}])
          }, null, 8, ["sku", "alt", "class"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h5", _hoisted_7, _toDisplayString(item.name), 1),
          (!item.selectable && __props.errorLabel)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.errorLabel), 1))
            : _createCommentVNode("", true)
        ])
      ], 10, _hoisted_1))
    }), 128))
  ]))
}
}

})